import { TimeSlot } from "@/types/doctor.definition";
import { getDateOfWeek } from "@/utils/date.utils";

export type AvailabilityRequestRange = {
  startDate: string; // yyyy-MM-dd
  endDate: string; // yyyy-MM-dd
  startTime: string; // HH:mm
  endTime: string; // HH:mm
  daysOfWeek: string[]; // MONDAY...
};

const minutes = (time: string): number => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

/**
 * MED-1687: the doctor's existing slots that medecine360-api would refuse the request for
 * (AVAILABILITY_ALREADY_EXISTS), with its rule: same day of week inside the date range and
 * strictly overlapping times. Every facility and every status counts, as in the API.
 */
export const findOverlappingSlots = (
  slots: TimeSlot[],
  request: AvailabilityRequestRange,
): TimeSlot[] => {
  const requestStart = minutes(request.startTime);
  const requestEnd = minutes(request.endTime);
  return slots
    .filter(
      (slot) =>
        slot.slotDate >= request.startDate &&
        slot.slotDate <= request.endDate &&
        request.daysOfWeek.includes(getDateOfWeek(slot.slotDate) ?? "") &&
        minutes(slot.slotStartTime) < requestEnd &&
        minutes(slot.slotEndTime) > requestStart,
    )
    .sort((a, b) =>
      `${a.slotDate}${a.slotStartTime}`.localeCompare(`${b.slotDate}${b.slotStartTime}`),
    );
};
